const ProjectStatusEnum = Object.freeze({
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  DELETE_IN_PROGRESS: 'delete in progress'
})

export { ProjectStatusEnum }



// WEBPACK FOOTER //
// ./src/common/enum/ProjectStatusEnum.js